import styled from "styled-components";
import { LoyaltyPointsV2 } from "styles/general_styles";

export const OffersStyled = styled.div`
	position: absolute;
	bottom: 0%;
	right: 0px;
	left: 0px;

	display: flex;
	justify-content: center;
	padding: 0.4375em;
	//font-size: 1.1rem;

	@media (max-width: 733px) {
		font-size: clamp(1px, 3.4dvw, 30px);
		//width: 100%;
		height: 78%;
		align-items: center;
		flex-direction: column;
		flex-wrap: nowrap;
		&::-webkit-scrollbar {
			width: 0;
		}
	}

	@media (min-width: 734px) {
		font-size: clamp(1px, 1.47dvw, 19px);
		height: 59%;
		align-items: center;
		flex-wrap: nowrap;
	}
`;

export const OfferItem = styled.div`
	//display: grid;
	grid-template-rows: auto;
	background-color: rgba(51, 51, 51, 0.6);
	border: 0.0625em solid #9aeffc;
	border-radius: 12px;
	padding: 0.5em;
	gap: 0.5em;
	margin: 0.1875em;
	width: 12.5em;
	height: auto;
	z-index: 999;
	align-content: stretch;

	@media (max-width: 733px) {
		width: 90%;
		&.one-item {
			min-width: unset;
			img {
				width: 4.625em;
				height: 4.625em;
			}
		}
		&.two-items {
			min-width: 15.625em;
			img {
				width: 4.375em;
				height: 4.375em;
			}
		}
		&.several-items {
			img {
				width: 100%;
				height: 4.375em;
			}
			min-width: 12.5em;
		}
	}
	@media (min-width: 734px) {
		gap: 1.2em;
		img {
			width: 3.9em;
			height: 3.9em;
		}
		&.one-item {
			min-width: 25em;
			width: auto;
		}
		&.two-items {
			min-width: 21.875em;
		}
		&.several-items {
			min-width: 18.75em;
		}
	}
`;

export const Items = styled.div`
	justify-content: center;
	align-items: end;
	display: flex;
	flex-wrap: wrap;
`;
/* eslint-disable */
export const RewardItem = styled.div<any>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
	padding: 0.0625em;
	//gap: 0.4rem;
`;
/* eslint-enable */

export const RewardAmount = styled.div`
	color: #fff;
	font-weight: 700;
	font-size: 1em;
`;

export const ItemImage = styled.img`
	width: 2.875em;
	height: 2.875em;
	object-fit: contain;
	justify-self: center;
	align-self: center;
`;

export const Footer = styled.div`
	display: grid;
	align-items: center;
	button {
		padding: 0.5em 0.2em;
		gap: 0.4em;
	}

	&.one-item {
		margin-top: 0.4em;
	}

	&.loyalty-reward {
		grid-template-columns: auto auto;
		grid-gap: 0.6em;

		@media (max-width: 733px) {
			grid-template-columns: auto 45%;
			&.one-item {
				display: flex;
				flex-direction: column;
				align-items: center;
				width: 100%;
				button {
					width: 100%;
				}
			}
		}
	}
`;

export const CustomLoyaltyPointsV2 = styled(LoyaltyPointsV2)`
	font-size: 1em;
	min-height: 1.5em;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	line-height: auto;
	padding: 0.2em 0.8em;
	gap: 0.1em;
`;

export const LoyaltyValue = styled.div`
	font-size: 0.9em;
	line-height: 0.9em;
`;

// deprecated v1
export const LoyaltyPoints = styled.div`
	background-color: rgba(0, 0, 0, 0.51);
	color: #fff;
	font-size: 0.9em;
	padding: 0.5em 0.8em;
	margin: 0.3em 0em;
	border-radius: 100px;

	> div {
		align-items: center;
		justify-content: center;
		display: flex;
		gap: 0.2em;
	}
`;
